module.exports = __webpack_public_path__ + "static/media/home-display-1.d5d73174.jpg";